<div>
  <form (ngSubmit)="onSubmit()" [formGroup]="form" class="form-container">
    <div *ngFor="let formItem of formItems" class="form-row">
      <app-form-item [formItem]="formItem" [form]="form"></app-form-item>
    </div>

    <div class="form-row-controls">
      <button type="reset" class="btn">Limpar</button>
      <button type="submit" class="btn filled" [disabled]="!form.valid">
        Criar
      </button>
    </div>
  </form>
</div>
